import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as HomeCareApi from './api';
import * as HomeCareActionType from './constants';
import * as NotifyActionType from 'Notification/constants';

export function* getArticlesCategoriesAsync(action) {
  const result = yield call(HomeCareApi.getArticlesCategories);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: HomeCareActionType.GET_ARTICLES_CATEGORIES_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data
    });
  }
}

export function* getArticlesListAsync(action) {
  const result = yield call(HomeCareApi.getArticlesList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: HomeCareActionType.GET_ARTICLES_LIST_SUCCESS,
      data: result.data,
      categoryId: action.params.id
    });
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR,
      data: result.data
    });
  }
}

export default function* HomeCareSaga() {
  yield all([
    takeLatest(HomeCareActionType.GET_ARTICLES_CATEGORIES_ASYNC, getArticlesCategoriesAsync),
    takeLatest(HomeCareActionType.GET_ARTICLES_LIST_ASYNC, getArticlesListAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/HomeCare/saga.js